index = require('./index')
global[k] = v for k, v of index
